<template>
  <div class="overflow-x-hidden">
    <div>
      <div class="row" style="margin-left: 150px; margin-top: 50px">
        <pl-button @click.native="$router.go(-1)" class="pl-primary">
          GO BACK
        </pl-button>
      </div>
    </div>
    <div class="w-3/4 mx-52 mb-14">
      <!-- Online Roundtables -->
      <div class="welcome-online-rts mt4">
        <div class="row">
          <div class="col-md-12">
            <span class="sub-title"> Written RoundTable </span>
          </div>
        </div>
        <div class="row mt3">
          <div class="col-md-6">
            <div class="row">
              <div class="col-md-12">
                <span class="tab-title"> Teachers </span>
                <toggle-button
                  :sync="true"
                  :labels="true"
                  v-model="ort_teachers_settings.enabled"
                  class="ml2"
                  color="#72ccd7"
                />
              </div>
            </div>
            <div class="row mt3">
              <div class="col-md-12">
                <pl-input
                  placeholder="YouTube Video"
                  v-model="ort_teachers_settings.video_url"
                />
              </div>
            </div>
            <div class="row mt1" v-for="(link, index) in ort_teachers_settings.links" :key="index">
              <div class="col-md-6">
                <pl-input
                  :placeholder="'Link ' + getPostion(index) + ' Name'"
                  v-model="link.name"
                  :class="[invalidName(link) ? 'invalidField' : '']"
                />
              </div>
              <div class="col-md-6">
                <pl-input
                  :placeholder="'Link ' + getPostion(index) + ' URL'"
                  v-model="link.url"
                  :class="[invalidURL(link) ? 'invalidField' : '']"
                />
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="row">
              <div class="col-md-12">
                <span class="tab-title"> Students </span>
                <toggle-button
                  :sync="true"
                  :labels="true"
                  v-model="ort_students_settings.enabled"
                  class="ml2"
                  color="#72ccd7"
                />
              </div>
            </div>
            <div class="row mt3">
              <div class="col-md-12">
                <pl-input
                  placeholder="YouTube Video"
                  v-model="ort_students_settings.video_url"
                />
              </div>
            </div>
            <div class="row mt1" v-for="(link, index) in ort_students_settings.links" :key="index">
              <div class="col-md-6">
                <pl-input
                  :placeholder="'Link ' + getPostion(index) + ' Name'"
                  v-model="link.name"
                  :class="[invalidName(link) ? 'invalidField' : '']"
                />
              </div>
              <div class="col-md-6">
                <pl-input
                  :placeholder="'Link ' + getPostion(index) + ' URL'"
                  v-model="link.url"
                  :class="[invalidURL(link) ? 'invalidField' : '']"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- Live Roundtables -->
      <div class="welcome-live-rts mt4">
        <div class="row">
          <div class="col-md-12">
            <span class="sub-title">Verbal RoundTable </span>
          </div>
        </div>
        <div class="row mt3">
          <div class="col-md-6">
            <div class="row">
              <div class="col-md-12">
                <span class="tab-title"> Teachers </span>
                <toggle-button
                  :sync="true"
                  :labels="true"
                  v-model="lrt_teachers_settings.enabled"
                  class="ml2"
                  color="#72ccd7"
                />
              </div>
            </div>
            <div class="row mt3">
              <div class="col-md-12">
                <pl-input
                  placeholder="YouTube Video"
                  v-model="lrt_teachers_settings.video_url"
                />
              </div>
            </div>
            <div
              class="row mt1"
              v-for="(link, index) in lrt_teachers_settings.links" :key="index"
            >
              <div class="col-md-6">
                <pl-input
                  :placeholder="'Link ' + getPostion(index) + ' Name'"
                  v-model="link.name"
                  :class="[invalidName(link) ? 'invalidField' : '']"
                />
              </div>
              <div class="col-md-6">
                <pl-input
                  :placeholder="'Link ' + getPostion(index) + ' URL'"
                  v-model="link.url"
                  :class="[invalidURL(link) ? 'invalidField' : '']"
                />
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="row">
              <div class="col-md-12">
                <span class="tab-title"> Students </span>
                <toggle-button
                  :sync="true"
                  :labels="true"
                  v-model="lrt_students_settings.enabled"
                  class="ml2"
                  color="#72ccd7"
                />
              </div>
            </div>
            <div class="row mt3">
              <div class="col-md-12">
                <pl-input
                  placeholder="YouTube Video"
                  v-model="lrt_students_settings.video_url"
                />
              </div>
            </div>
            <div
              class="row mt1"
              v-for="(link, index) in lrt_students_settings.links" :key="index"
            >
              <div class="col-md-6">
                <pl-input
                  :placeholder="'Link ' + getPostion(index) + ' Name'"
                  v-model="link.name"
                  :class="[invalidName(link) ? 'invalidField' : '']"
                />
              </div>
              <div class="col-md-6">
                <pl-input
                  :placeholder="'Link ' + getPostion(index) + ' URL'"
                  v-model="link.url"
                  :class="[invalidURL(link) ? 'invalidField' : '']"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- Sample RoundTables -->
      <div class="welcome-online-rts mt4">
        <div class="row">
          <div class="col-md-12">
            <span class="sub-title">Sample RoundTables</span>
          </div>
        </div>
        <div class="row mt3">
          <div class="col-md-6">
            <div class="row">
              <div class="col-md-12">
                <span class="tab-title">Written RoundTable</span>
              </div>
            </div>
            <div class="row mt3">
              <div class="col-md-12">
                <pl-input
                  placeholder="YouTube Video"
                  v-model="sample_written_settings.video_url"
                />
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="row">
              <div class="col-md-12">
                <span class="tab-title"> Verbal RoundTable </span>
              </div>
            </div>
            <div class="row mt3">
              <div class="col-md-12">
                <pl-input
                  placeholder="YouTube Video"
                  v-model="sample_verbal_settings.video_url"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="centered-div mt4">
        <pl-button class="pl-primary" @click.native="saveChanges">
          Save Changes
        </pl-button>
      </div>
    </div>
  </div>
</template>

<script>
  import updateWelcomeSettings from 'services/account/updateWelcomeSettings';
  import getWelcomeSettings from '../../services/account/getWelcomeSettings';
  import { EventBus } from 'utils/event-bus';

  export default {
    data() {
      return {
        allSettings: [],
        n_links: 5,
        lrt_students_settings: {},
        lrt_teachers_settings: {},
        ort_students_settings: {},
        ort_teachers_settings: {},
        sample_verbal_settings: {},
        sample_written_settings: {}
      };
    },
    methods: {
      invalidName(link) {
        if (link && link.url && !link.name) {
          return true;
        }
        return false;
      },
      invalidURL(link) {
        if (link && !link.url && link.name) {
          return true;
        }
        return false;
      },
      getPostion(index) {
        return index + 1;
      },
      saveChanges() {
        const ort_teachers_settings = Object.assign({}, this.ort_teachers_settings);
        const ort_students_settings = Object.assign({}, this.ort_students_settings);
        const lrt_teachers_settings = Object.assign({}, this.lrt_teachers_settings);
        const lrt_students_settings = Object.assign({}, this.lrt_students_settings);
        const sample_written_settings = Object.assign({links: [], type: 'sample_written', role:'teacher', enabled: true, id: '02d7ca93-3332-11eb-84ef-c71ce4f8ad56'}, this.sample_written_settings);
        const sample_verbal_settings = Object.assign({links: [], type: 'sample_written', role:'teacher', enabled: true, id: '02d7ca94-3332-11eb-84ef-c71ce4f8ad56'}, this.sample_verbal_settings);
        const payload = [];
        payload.push(ort_teachers_settings);
        payload.push(ort_students_settings);
        payload.push(lrt_teachers_settings);
        payload.push(lrt_students_settings);
        payload.push(sample_written_settings);
        payload.push(sample_verbal_settings);
        payload.forEach((element) => {
          // clean links without name or url
          element.links = element.links.filter(
            (x) => x.name.length > 0 && x.url.length > 0
          );
        });
        this.updateWelcomeSettingsOnDB(payload);
      },
      fillEmptyObjects() {
        for (let index = 0; index < this.n_links; index += 1) {
          if (this.lrt_students_settings.links.length < this.n_links) {
            this.lrt_students_settings.links.push({ name: '', url: '' });
          }
          if (this.lrt_teachers_settings.links.length < this.n_links) {
            this.lrt_teachers_settings.links.push({ name: '', url: '' });
          }
          if (this.ort_students_settings.links.length < this.n_links) {
            this.ort_students_settings.links.push({ name: '', url: '' });
          }
          if (this.ort_teachers_settings.links.length < this.n_links) {
            this.ort_teachers_settings.links.push({ name: '', url: '' });
          }
        }
      },
      updateWelcomeSettingsOnDB(welcomeSetting) {
        updateWelcomeSettings(welcomeSetting).then(() => {
          EventBus.$emit('toast-msg', 'Welcome Settings Successfully Saved !');
        }).catch(console.error);
      },
      getLinks() {
        getWelcomeSettings.getSettings().then((data) => {
            this.allSettings = data;
            this.setWelcomeSettings(data);
          })
          .catch(console.error);
      },
      setWelcomeSettings(data) {
        data.forEach((setting) => {
          if (setting.role === 'teacher' && setting.roundtable_type === 'online') {
            this.ort_teachers_settings = setting;
          } else if (setting.role === 'student' && setting.roundtable_type === 'online') {
            this.ort_students_settings = setting;
          } else if (setting.role === 'teacher' && setting.roundtable_type === 'live') {
            this.lrt_teachers_settings = setting;
          } else if (setting.role === 'student' && setting.roundtable_type === 'live') {
            this.lrt_students_settings = setting;
          } else if(setting.role === 'teacher' && setting.roundtable_type === 'sample_written'){
            this.sample_written_settings = setting;
          } else if(setting.role === 'teacher' && setting.roundtable_type === 'sample_verbal'){
            this.sample_verbal_settings = setting;
          } else {
            // something went wrong, please call tecnhical
          }
        });
        this.fillEmptyObjects();
      },
    },
    created() {
      this.getLinks();
    },
    mounted() {},
  };
</script>

<style lang="stylus" scoped>
  @import '~app/global-stylus.styl';

  .container
      width: 1000px
      height: 86vh
      overflow: auto

  .sub-title
      font-size: 24px;
      color: #273248;
      font-weight: bold;
  .tab-title
      font-size: 16px;
      font-weight: 600;
  .centered-div
      display: flex;
      align-items: center;
      justify-content: center;

  .invalidField
      border: 2px solid pl-ruby !important;
      border-radius: 5px;
      outline: none;
</style>



// WEBPACK FOOTER //
// adminWelcomeModals.vue?c8af587a